/**
 * Chip that indicates the trigger event type.
 */

import {assertUnreachable} from '@wandb/weave/common/util/types';
import React from 'react';

import {EventTriggeringConditionType} from './TriggerEventTypes';

type EventTypeChipProps = {
  eventType: EventTriggeringConditionType;
};

export const EventTypeChip = ({eventType}: EventTypeChipProps) => {
  switch (eventType) {
    case EventTriggeringConditionType.CreateArtifact: {
      return <div>New version</div>;
    }
    case EventTriggeringConditionType.LinkModel: {
      return <div>New version</div>;
    }
    case EventTriggeringConditionType.AddArtifactAlias: {
      return <div>New alias</div>;
    }
    // Update alias triggers have been deprecated
    case EventTriggeringConditionType.UpdateArtifactAlias: {
      return <div>Update alias</div>;
    }
    case EventTriggeringConditionType.RunMetric: {
      return <div>Run metrics threshold met</div>;
    }
    case EventTriggeringConditionType.RunMetricChange: {
      return <div>Run metrics change threshold met</div>;
    }
    case EventTriggeringConditionType.RunState: {
      return <div>Run status change</div>;
    }
    default: {
      assertUnreachable(eventType);
    }
  }
};
